var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeCube(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_26710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 78.0693L40.1978 170.664L102.485 92.593L62.2872 0.000518799L0 78.0693Z",
    fill: "url(#paint0_linear_903_26710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.483 92.5926L189 103.189L148.799 10.597L62.2852 9.15527e-05L102.483 92.5926Z",
    fill: "url(#paint1_linear_903_26710)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1992 170.662L126.714 181.259L189.003 103.188L102.486 92.5909L40.1992 170.662Z",
    fill: "url(#paint2_linear_903_26710)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_903_26710",
    x1: 14.0987,
    y1: 48.1888,
    x2: 88.386,
    y2: 122.476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C07BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.176649,
    stopColor: "#C07BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9535DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_903_26710",
    x1: 141.799,
    y1: 115.184,
    x2: 109.484,
    y2: -11.9929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8700CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9024E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_903_26710",
    x1: 191.474,
    y1: 129.78,
    x2: 37.7274,
    y2: 144.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#52059B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9024E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_26710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeCube);
export default __webpack_public_path__ + "static/media/Type=Cube.d45957e770f18f5348e0b561a573d5d4.svg";
export { ForwardRef as ReactComponent };